const KEY = "de-inquiry-prefill";
export const PREFILL_EVENT = "de:inquiry-prefill";

export const setInquiryPrefill = (label) => {
  if (!label) return;
  sessionStorage.setItem(KEY, label);
  window.dispatchEvent(new CustomEvent(PREFILL_EVENT, { detail: label }));
};

export const takeInquiryPrefill = () => {
  const v = sessionStorage.getItem(KEY);
  if (v) sessionStorage.removeItem(KEY);
  return v;
};
